<template>
    <div style="" class="col-md-8 right-level-1  bgColorRight ">
        <div class="personInfo row  ">
            <div class="col-sm-5 personLeft">
                <!---REHÁK-->
                <span class="name">Rastislav</span> <span class="name surName">{{$t("concat.1")}}</span>
                <!--Softvérový vývojár-->
                <div class="info profi">{{$t("concat.2")}}</div>
                <div class="info-price profi-price">
                    <!--Cena&nbsp;(md)&nbsp;od:&nbsp;-->
                    <!--{{$t("concat.3-2")}}&nbsp;-->
                    <!--{{$t("concat.3-1")}}&nbsp;{{$t("concat.3-3")}}&nbsp;<span class="price">250&nbsp;€</span>&nbsp;{{$t("concat.3-2")}}--->
                    
                    <!--<span   style="color:red;">{{ getWidth() }} / {{ getHeight() }}</span>-->
                </div>
            </div>
            <div class="pl-1 pr-0 col-sm-7 personRight ">
                <div  class="d-flex justify-content-left  concat-title clearfix ">
                    <!---Kontakt-->
                    <span class="concat">{{$t("concat.4")}}</span>
                </div>
                <div style="" class="d-flex justify-content-left infoLine mt-3 border clearfix">
                    <i class="fas fa-phone-volume icon"></i>
                    <span class="info telNumber">+421 904 478 738</span>
                </div>
                <div style="" class="d-flex justify-content-left infoLine mt-1 border clearfix">
                    <i class="fas fa-envelope-square icon"></i>
                    <span class="info email">rasto@abnet.sk</span>
                </div>
                <div style="" class="d-flex justify-content-left infoLine mt-1 border clearfix">
                    <i class="fas fa-home icon"></i>
                    <span class="info address">Karadžičova 4111/47</span>
                </div>

                <div style="" class="d-flex justify-content-left infoLine mt-1 border clearfix">
                    <i class="fas fa-space-station-moon-alt icon"></i>
                    <span class="info city">811 07 Bratislava I,</span>
                </div>

                <div style="" class="d-flex justify-content-left infoLine mt-1 border clearfix">
                    <i class="fas fa-space-station-moon-alt icon"></i>
                    <span class="info slovakia">{{ $t('concat.5')  }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            getWidth()  {
                return window.screen.width
            },
            getHeight() {
                return window.screen.height
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>